import { render, staticRenderFns } from "./InvoiceDialog.vue?vue&type=template&id=8c949808&"
import script from "./InvoiceDialog.vue?vue&type=script&lang=ts&"
export * from "./InvoiceDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports